export default function() {
  const checkCustomerForm = document.querySelector('.newsletter__check_customer');
  const existingCustomerForm = document.querySelector('.newsletter_existing_customer');
  const newCustomerForm = document.querySelector('.newsletter_new_customer');
  const customerHasNoEmail = document.getElementById('customerHasNoEmail');
  const confirmationPage = document.getElementById('confirmationPage');

  // check if new customer or if existing data needs to be updated
  const checkCustomer = () => {
    checkCustomerForm.addEventListener('submit', e => {
      e.preventDefault();
      const email = document.getElementById('newsletter-email').value;
      fetch('https://www.brandsonly.be/apps/helper/check-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === 'create') {
            window.location = '/pages/nieuwe-klant';
          } else if (data.status === 'update') {
            localStorage.setItem('contact', JSON.stringify(data.data));
            window.location = '/pages/bestaande-klant';
          } else {
            localStorage.setItem('contact', JSON.stringify(data.data));
            window.location = '/pages/update-klant';
          }
        });
    });
  };

  // update customer details
  const existingCustomer = () => {
    const contact = JSON.parse(localStorage.getItem('contact'));
    const receiveMail = document.getElementById('post');
    const addressDetails = document.getElementById('form__address-fields');
    const queryString = window.location.search.split('=')[1];
    const loadingSpinner = document.getElementById('loadingSpinner');

    if (queryString) {
      customerHasNoEmail.hidden = false;

      const formDataObject = {
        uuid: queryString,
      };
      const formDataJson = JSON.stringify(formDataObject);

      fetch('https://www.brandsonly.be/apps/helper/qr', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: formDataJson,
      })
        .then(response => response.json())
        .then(data => {
          loadingSpinner.classList.add('vh');
          localStorage.setItem('contact', JSON.stringify(data.data));
          document.getElementById('existing_first-name').value = data.data.firstName;
          document.getElementById('existing_last-name').value = data.data.lastName;
          document.getElementById('existing_email').value = data.data.email;
          document.getElementById('existing_address').value = data.data.address;
          document.getElementById('existing_postal_code').value = data.data.postalCode;
          document.getElementById('existing_house_number').value = data.data.houseNumber;
          document.getElementById('existing_bus_number').value = data.data.busNumber;
          document.getElementById('existing_city').value = data.data.city;
        });
    }
    receiveMail.addEventListener('change', () => {
      addressDetails.classList.toggle('vh');
      const emailFormElement = document.getElementById('emailFormElement');
      emailFormElement.hidden = false;
      customerHasNoEmail.hidden = false;
    });

    if (contact) {
      loadingSpinner.classList.add('vh');
      document.getElementById('existing_first-name').value = contact.firstName;
      document.getElementById('existing_last-name').value = contact.lastName;
      document.getElementById('existing_email').value = contact.email;
      document.getElementById('existing_address').value = contact.address;
      document.getElementById('existing_postal_code').value = contact.postalCode;
      document.getElementById('existing_house_number').value = contact.houseNumber;
      document.getElementById('existing_bus_number').value = contact.busNumber;
      document.getElementById('existing_city').value = contact.city;
    }

    existingCustomerForm.addEventListener('submit', e => {
      e.preventDefault();
      const emailFormElement = document.getElementById('emailFormElement');
      const tagInputs = document.getElementsByName('tags[]');
      const tagsArray = [];

      if (emailFormElement.hidden) {
        const name = document.getElementById('existing_first-name').value;
        const lastName = document.getElementById('existing_last-name').value;

        document.getElementById('existing_email').value = `${name}.${lastName}@activecampaign.com`;
      }
      const formData = new FormData(existingCustomerForm);

      tagInputs.forEach(input => {
        if (input.checked) {
          tagsArray.push(input.value);
        }
      });

      const formDataObject = {};
      formData.forEach(function(value, key) {
        formDataObject[key] = value;
      });
      formDataObject['tags[]'] = tagsArray;
      const formDataJson = JSON.stringify(formDataObject);

      fetch('https://www.brandsonly.be/apps/helper/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: formDataJson,
      })
        .then(response => response.json())
        .then((window.location = '/pages/success'));
    });
  };

  // add new customer
  const newCustomer = () => {
    const receiveMail = document.getElementById('post');
    const addressDetails = document.getElementById('form__address-fields');
    receiveMail.addEventListener('change', () => {
      addressDetails.classList.toggle('vh');
    });
    newCustomerForm.addEventListener('submit', e => {
      e.preventDefault();
      const formData = new FormData(newCustomerForm);

      const tagInputs = document.getElementsByName('tags[]');
      const tagsArray = [];
      tagInputs.forEach(input => {
        if (input.checked) {
          tagsArray.push(input.value);
        }
      });

      const formDataObject = {};
      formData.forEach(function(value, key) {
        formDataObject[key] = value;
      });
      formDataObject['tags[]'] = tagsArray;
      const formDataJson = JSON.stringify(formDataObject);

      fetch('https://www.brandsonly.be/apps/helper/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: formDataJson,
      })
        .then(response => response.json())
        .then((window.location = '/pages/success'));
    });
  };

  const confirmation = () => {
    console.log('confirmation page');
    const queryString = window.location.search.split('=')[1];

    if (queryString) {
      console.log(queryString);
      const formDataObject = {
        email: queryString,
      };
      const formDataJson = JSON.stringify(formDataObject);

      fetch('https://www.brandsonly.be/apps/helper/update-timestamp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: formDataJson,
      }).then(response => response.json());
    }
  };

  if (checkCustomerForm) {
    checkCustomer();
  }

  if (existingCustomerForm) {
    existingCustomer();
  }

  if (newCustomerForm) {
    newCustomer();
  }

  if (confirmationPage) {
    confirmation();
  }

  if (customerHasNoEmail) {
    customerHasNoEmail.addEventListener('click', e => {
      e.preventDefault();
      const emailFormElement = document.getElementById('emailFormElement');
      const postInput = document.getElementById('post');

      emailFormElement.hidden = true;
      postInput.checked = true;
      const addressDetails = document.getElementById('form__address-fields');
      addressDetails.classList.toggle('vh');
    });
  }
}
